<div class="questionnaire-title-layout">{{questionnaireTitle}}</div>



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-title/questionnaire-title.component.html